export default function NotFound() {
  return (
    <div className="h-screen overflow-auto flex justify-center items-center text-center">
      <h1 className="text-4xl">Page not found</h1>
    </div>
  );
}
